export const chartSettingsAsyncModule = {
  importFn: () => import(/* webpackChunkName: "chart-settings" */ './module-entry'),
  cacheKey: 'chart-settings',
}
